<template>
  <div class="page">
    <div class="select">
      <div>推广服务区域</div>
      <div @click="showArea">{{ fullAddress ? fullAddress : '请选择省市区' }}</div>
    </div>
    <van-popup v-model="show" :style="{ width: '100%' }" position="bottom">
      <van-picker title="" show-toolbar :columns="columns" @cancel="show = false" @confirm="onConfirm" />
    </van-popup>

    <div class="content">
      <h3>须知</h3>
      <p>1、积极正能量传递和分享大健康盘古商业系统；</p>
      <p>2、严于律己，不得私自收受门店信息技术服务费；</p>
      <p>3、积极参加所在区/县服务中心的例行会议及培训；</p>
      <p>4、严格遵守平台及所在区/县服务中心的规章制度；</p>
      <p>5、不得夸大和虚假宣传，否则承担一切法律责任；</p>
      <p>6、严格遵守平台规定，接受平台及服务中心考核；</p>
      <p>7、法律关系系合作关系，非劳动合同或劳务合同关系。</p>
      <p>本人已知悉以上内容，自愿加入大健康盘古商业系统创业团队，成为大健康创业人员。</p>
    </div>
    <van-button :disabled="!!id" @click="submit" class="btn" type="danger" block>
      <div style="display: flex;">
        <van-checkbox disabled class="checkbox" v-if="time" v-model="time"></van-checkbox>
        我知晓并理解同意所有服务合作事项
      </div>
      <div v-if="time">{{ time }}</div>
    </van-button>
  </div>
</template>
<script>
import { Picker, Popup, Button, Toast, Checkbox } from 'vant'
import { post } from '@/utils/request'
import { backOff } from '@/utils/userInfo'
import area from './area'

export default {
  components: {
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      show: false,
      columns: area,
      selectData: [],
      token: '',
      id: '',
      time: ''
    }
  },
  computed: {
    fullAddress() {
      return this.selectData.join("")
    }
  },
  created() {
    this.$bridge.callHandler('getUserInfo', {}, (res) => {
      const d = JSON.parse(res)
      this.token = d.data.accessToken
      this.getStatus()
    })
  },
  methods: {
    showArea() {
      if (this.id) {
        return
      }
      this.show = true
    },

    onConfirm(value) {
      this.selectData = value
      this.show = false
    },

    getStatus() {
      post({
        url: '/healthy/auth/providerStore/getPromoter',
        options: {
          token: this.token
        }
      }).then(res => {
        if (res.code === 0 && res.data && res.data.id) {
          this.id = res.data.id
          this.selectData = [res.data.provinceName, res.data.cityName, res.data.areaName]
          this.time = res.data.createTime
        }
      })
    },

    submit() {
      if (!this.selectData.length) {
        Toast('请选择省市区')
        return
      }
      post({
        url: '/healthy/auth/providerStore/addPromoter',
        data: {
          provinceName: this.selectData[0],
          cityName: this.selectData[1],
          areaName: this.selectData[2],
        },
        options: {
          token: this.token
        }
      }).then(res => {
        if (res.code === 0) {
          Toast('提交成功')
          setTimeout(() => {
            backOff()
          }, 2000);
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.page {
  padding: 20px;
  background: #fff;
}

.btn {
  margin-top: 50px;
  border-radius: 10px;
}

.select {
  display: flex;
  justify-content: space-between;
}

.checkbox {
  margin-right: 10px;
}

.content {
  padding-top: 40px;
}

h3 {
  text-align: center;
}
</style>